import HttpClient from '../../../services/http-client';
import { Pagination } from '../../../../model/pagination';
import { IPaymentAddEditRequest } from '../../../../model/sge/payment/request/payment-add-edit-request';
import { IPaymentPagedRequest } from '../../../../model/sge/payment/request/payment-paged-request';
import { IPaymentResponse } from '../../../../model/sge/payment/response/payment-response';

const basePath = (liquidationId: number) => `Liquidations/${liquidationId}/Payments`;

const list = async (liquidationId: number, params: Omit<IPaymentPagedRequest, 'liquidationId'>): Promise<Pagination<IPaymentResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(liquidationId)}`,
        params
    }).then((response) => Object.assign(new Pagination<IPaymentResponse>(), response.data));
};

const getById = async (liquidationId: number, id: number): Promise<IPaymentResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(liquidationId)}/${id}`
    }).then((response) => response.data);
};

const add = async (liquidationId: number, params: IPaymentAddEditRequest): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'post',
        url: `/${basePath(liquidationId)}`,
        data: params
    });
};

const edit = async (liquidationId: number, id: number, params: IPaymentAddEditRequest): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${basePath(liquidationId)}/${id}`,
        data: params
    });
};

const remove = async (liquidationId: number, id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${basePath(liquidationId)}/${id}`
    });
};

const PaymentAppService = { list, getById, add, edit, remove };
export default PaymentAppService;
